/*
 *
 * Constants: `@dbh/text-area-theme`.
 *
 */const THEME_KEY_TEXT_AREA="textAreaTheme";

const modifyTextAreaTheme=a=>{let{colors:{greyMid:b,greyUltralight:c}}=a;return {[THEME_KEY_TEXT_AREA]:{disabledBackgroundColor:c,disabledFontColor:b}}};

export { THEME_KEY_TEXT_AREA, modifyTextAreaTheme as default };
